import { Link, Stack, SxProps, Theme, Typography } from '@mui/material';

interface CPLinkProps {
  label: string;
  prefix?: string;
  onClick?: () => void;
  spacing?: number;
  underline?: "none" | "hover" | "always";
  sx?: SxProps<Theme>;
  className?: string;
}

export function CPLink({
  label = "",
  prefix = "",
  onClick = () => {},
  spacing = 1,
  underline = "none",
  sx = {},
  ...props
}: CPLinkProps) {
  return (
    <Stack 
      direction="row" 
      spacing={spacing}
      alignItems="center"
      justifyContent="center"
      sx={sx}
      className={props.className}
    >

      <Typography sx={{ fontSize: '14px' }}>
        {prefix + " "}
        <Link
          component="button"
          underline={underline}
          onClick={onClick}>
        {label}
        </Link>
      </Typography>

    </Stack>
  );
};

export default CPLink;